export default (property: Object): property is Scope.Property<any> =>
  property && typeof property === 'object' && '$c' in (property as any);
